import React from "react";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const Snackbars = ({
  successMessage,
  setSuccessMessage,
  errorMessage,
  setErrorMessage,
  isLoading,
}) => {
  return (
    <>
      {/* Success Snackbar */}
      <Snackbar
        open={!!successMessage}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setSuccessMessage("")}
      >
        <Alert
          severity="success"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "auto",
            maxWidth: "100%",
            mx: "auto",
          }}
        >
          {successMessage}
        </Alert>
      </Snackbar>

      {/* Loading Snackbar */}
      <Snackbar
        open={isLoading}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="info"
          icon={<CircularProgress size={18} />}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "auto",
            maxWidth: "100%",
            mx: "auto",
          }}
        >
          Loading, please wait...
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={!!errorMessage}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setErrorMessage("")}
      >
        <Alert
          severity="error"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "auto",
            maxWidth: "100%",
            mx: "auto",
          }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Snackbars;
